import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ExtractedRow } from '../../models/extracted-values';
import { WordRect } from '@ps-gui/claims-terminal-shared';
import { TableData } from '../../table-overlay/table-overlay';

export interface CreatedTable {
  tableData: TableData;
  rows: ExtractedRow[];
  suggestedFieldLocations: Record<string, WordRect>;
}

@Injectable({
  providedIn: 'root',
})
//if table creation in overlay is confirmed a table is created
export class ExtractedTableCreationService {
  createdTable$: Subject<CreatedTable> = new Subject<CreatedTable>();

  createTable(tableRows: CreatedTable) {
    this.createdTable$.next(tableRows);
  }
}
